import { useI18n, useRouter } from '@popety_io/popety-io-lib'
import { useEffect } from 'react'
import { pricingOptions } from '../../../../../../utils/thematic/glossary/pricingOptions'
import {
  ESTIMATE_PURCHASE_APARTMENT,
  ESTIMATE_PURCHASE_HOUSE,
  ESTIMATE_RENT_APARTMENT,
  ESTIMATE_RENT_HOUSE,
} from '../../../../../../config'
import LegendSelector from '../../../../../../components/LegendSelector'

export const MarketMapContent = ({ type = 'purchase' }: { type: string }) => {
  const { t } = useI18n()
  const priceOptions = pricingOptions(t)

  const { updateQuery } = useRouter()
  const isRent = type === 'rental'

  useEffect(() => {
    const selected = isRent
      ? ESTIMATE_RENT_APARTMENT
      : ESTIMATE_PURCHASE_APARTMENT

    updateQuery({ marketLayer: selected })
  }, [])

  const options = [
    type === 'purchase' && {
      value: ESTIMATE_PURCHASE_APARTMENT,
      label: t('estimate.map.legend.market price'),
    },
    type === 'purchase' && {
      value: ESTIMATE_PURCHASE_HOUSE,
      label: t('estimate.map.legend.house_market_price'),
    },
    type === 'rental' && {
      value: ESTIMATE_RENT_APARTMENT,
      label: t('estimate.map.legend.market_rent_price_apartment'),
    },
    type === 'rental' && {
      value: ESTIMATE_RENT_HOUSE,
      label: t('estimate.map.legend.market_rent_price_house'),
    },
  ].filter(Boolean)

  return (
    <div>
      <LegendSelector
        options={options}
        legends={priceOptions?.[isRent ? 2 : 0]?.legend}
        value={
          type === 'purchase'
            ? ESTIMATE_PURCHASE_APARTMENT
            : ESTIMATE_RENT_APARTMENT
        }
        keyValue="marketLayer"
        legendValue="marketLegend"
        description={t('estimate.map.legend.market price description')}
      />
    </div>
  )
}
